<template>
    <div class="office-balance">
      <div class="rank">
        <div v-if="portfolio.rank == 0">
            <p>{{__('Инвестор')}}</p>
            <img src="/newfrontend/images/rank-1.png" alt="">
        </div>
          <div v-if="portfolio.rank == 1">
              <p>{{__('Инвестор')}}</p>
              <img src="/newfrontend/images/rank-1.png" alt="">
          </div>
          <div v-if="portfolio.rank == 2">
              <p>{{__('Инвестор')}}</p>
              <img src="/newfrontend/images/rank-1.png" alt="">
          </div>
          <div v-if="portfolio.rank == 3">
              <p>{{__('Инвестор')}}</p>
              <img src="/newfrontend/images/rank-1.png" alt="">
          </div>
          <div v-if="portfolio.rank == 4">
              <p>{{__('Инвестор')}}</p>
              <img src="/newfrontend/images/rank-1.png" alt="">
          </div>
          <div v-if="portfolio.rank == 5">
              <p>{{__('Инвестор')}}</p>
              <img src="/newfrontend/images/rank-1.png" alt="">
          </div>
          <div v-if="portfolio.rank == 6">
              <p>{{__('Инвестор')}}</p>
              <img src="/newfrontend/images/rank-1.png" alt="">
          </div>
          <div v-if="portfolio.rank == 7">
              <p>{{__('Бронзовый инвестор')}}</p>
              <img src="/newfrontend/images/rank-2.png" alt="">
          </div>
          <div v-if="portfolio.rank == 8">
              <p>{{__('Бронзовый инвестор')}}</p>
              <img src="/newfrontend/images/rank-2.png" alt="">
          </div>
          <div v-if="portfolio.rank == 9">
              <p>{{__('Бронзовый инвестор')}}</p>
              <img src="/newfrontend/images/rank-2.png" alt="">
          </div>
          <div v-if="portfolio.rank == 10">
              <p>{{__('Бронзовый инвестор')}}</p>
              <img src="/newfrontend/images/rank-2.png" alt="">
          </div>
          <div v-if="portfolio.rank == 11">
              <p>{{__('Бронзовый инвестор')}}</p>
              <img src="/newfrontend/images/rank-2.png" alt="">
          </div>
          <div v-if="portfolio.rank == 12">
              <p>{{__('Золотой инвестор')}}</p>
              <img src="/newfrontend/images/rank-3.png" alt="">
          </div>
          <div v-if="portfolio.rank == 13">
              <p>{{__('Золотой инвестор')}}</p>
              <img src="/newfrontend/images/rank-3.png" alt="">
          </div>
          <div v-if="portfolio.rank == 14">
              <p>{{__('Золотой инвестор')}}</p>
              <img src="/newfrontend/images/rank-3.png" alt="">
          </div>
          <div v-if="portfolio.rank == 15">
              <p>{{__('Золотой инвестор')}}</p>
              <img src="/newfrontend/images/rank-3.png" alt="">
          </div>
          <div v-if="portfolio.rank == 16">
              <p>{{__('Золотой инвестор')}}</p>
              <img src="/newfrontend/images/rank-3.png" alt="">
          </div>
          <div v-if="portfolio.rank == 17">
              <p>{{__('Платиновый инвестор')}}</p>
              <img src="/newfrontend/images/rank-4.png" alt="">
          </div>
          <div v-if="portfolio.rank == 18">
              <p>{{__('Платиновый инвестор')}}</p>
              <img src="/newfrontend/images/rank-4.png" alt="">
          </div>
          <div v-if="portfolio.rank == 19">
              <p>{{__('Партнёр')}}</p>
              <img src="/newfrontend/images/rank-5.png" alt="">
          </div>
          <div v-if="portfolio.rank == 20">
              <p>{{__('Бронзовый партнёр')}}</p>
              <img src="/newfrontend/images/rank-6.png" alt="">
          </div>
          <div v-if="portfolio.rank == 21">
              <p>{{__('Бронзовый партнёр')}}</p>
              <img src="/newfrontend/images/rank-6.png" alt="">
          </div>
          <div v-if="portfolio.rank == 22">
              <p>{{__('Золотой партнёр')}}</p>
              <img src="/newfrontend/images/rank-7.png" alt="">
          </div>
          <div v-if="portfolio.rank == 23">
              <p>{{__('Золотой партнёр')}}</p>
              <img src="/newfrontend/images/rank-7.png" alt="">
          </div>
          <div v-if="portfolio.rank == 24">
              <p>{{__('Платиновый партнёр')}}</p>
              <img src="/newfrontend/images/rank-8.png" alt="">
          </div>
          <div v-if="portfolio.rank == 25">
              <p>{{__('Дистрибьютор')}}</p>
              <img src="/newfrontend/images/rank-9.png" alt="">
          </div>
          <div v-if="portfolio.rank == 26">
              <p>{{__('Бронзовый дистрибьютор')}}</p>
              <img src="/newfrontend/images/rank-10.png" alt="">
          </div>
          <div v-if="portfolio.rank == 27">
              <p>{{__('Золотой дистрибьютор')}}</p>
              <img src="/newfrontend/images/rank-11.png" alt="">
          </div>
          <div v-if="portfolio.rank == 28">
              <p>{{__('Золотой дистрибьютор')}}</p>
              <img src="/newfrontend/images/rank-11.png" alt="">
          </div>
          <div v-if="portfolio.rank == 29">
              <p>{{__('Платиновый дистрибьютор')}}</p>
              <img src="/newfrontend/images/rank-12.png" alt="">
          </div>
          <div v-if="portfolio.rank == 30">
              <p>{{__('Лидер')}}</p>
              <img src="/newfrontend/images/rank-13.png" alt="">
          </div>
          <div v-if="portfolio.rank == 31">
              <p>{{__('Бронзовый лидер')}}</p>
              <img src="/newfrontend/images/rank-14.png" alt="">
          </div>
          <div v-if="portfolio.rank == 32">
              <p>{{__('Золотой лидер')}}</p>
              <img src="/newfrontend/images/rank-14.png" alt="">
          </div>
          <div v-if="portfolio.rank == 33">
              <p>{{__('Платиновый лидер')}}</p>
              <img src="/newfrontend/images/rank-16.png" alt="">
          </div>
          <div v-if="portfolio.rank == 34">
              <p>{{__('Директор')}}</p>
              <img src="/newfrontend/images/rank-17.png" alt="">
          </div>
          <div v-if="portfolio.rank == 35">
              <p>{{__('Бронзовый директор')}}</p>
              <img src="/newfrontend/images/rank-18.png" alt="">
          </div>
          <div v-if="portfolio.rank == 36">
              <p>{{__('Бронзовый директор')}}</p>
              <img src="/newfrontend/images/rank-18.png" alt="">
          </div>
          <div v-if="portfolio.rank == 37">
              <p>{{__('Золотой директор')}}</p>
              <img src="/newfrontend/images/rank-19.png" alt="">
          </div>
          <div v-if="portfolio.rank == 38">
              <p>{{__('Золотой директор')}}</p>
              <img src="/newfrontend/images/rank-19.png" alt="">
          </div>
          <div v-if="portfolio.rank == 39">
              <p>{{__('Платиновый директор')}}</p>
              <img src="/newfrontend/images/rank-20.png" alt="">
          </div>
          <div v-if="portfolio.rank == 40">
              <p>{{__('Акционер')}}</p>
              <img src="/newfrontend/images/rank-21.png" alt="">
          </div>
          <div v-if="portfolio.rank == 41">
              <p>{{__('Акционер')}}</p>
              <img src="/newfrontend/images/rank-21.png" alt="">
          </div>
          <div v-if="portfolio.rank == 42">
              <p>{{__('Бронзовый акционер')}}</p>
              <img src="/newfrontend/images/rank-22.png" alt="">
          </div>
          <div v-if="portfolio.rank == 43">
              <p>{{__('Бронзовый акционер')}}</p>
              <img src="/newfrontend/images/rank-22.png" alt="">
          </div>
          <div v-if="portfolio.rank == 44">
              <p>{{__('Золотой акционер')}}</p>
              <img src="/newfrontend/images/rank-23.png" alt="">
          </div>
          <div v-if="portfolio.rank == 45">
              <p>{{__('Платиновый акционер')}}</p>
              <img src="/newfrontend/images/rank-24.png" alt="">
          </div>

        <p class="rank-text"><span>{{portfolio.rank}} {{__('Rank')}}</span></p>
      </div>
      <div class="balance-bar">
          <p class="summ">{{$primNum(portfolio.turnover) | formatThousands}} <span>USD</span></p>
          <p class="text">{{__('Amount of team funds in farming')}}</p>
          <v-progress-linear
                  :value="value"
                  striped
                  color="light-blue"
                  class="progress-bar"
                  height="16px"
          >
          </v-progress-linear>
          <p class="text-b">
              <span>{{$primNum(portfolio.rang_turnover) | formatThousands}}</span>
              <span>{{$primNum(portfolio.next_rang_turnover) | formatThousands}}</span>
          </p>
      </div>
      <div class="right-balance">
          <div class="all-right">
              <div class="total">
                  <div class="img">
                      <span><img src="/newfrontend/images/top-wallet.svg" alt=""></span>
                  </div>
                  <div class="balance">
                      <span class="text">{{$primNum(portfolio.balance) | formatThousands}}</span>
                      <p class="semi"><span class="m-r">USDT</span> {{__('dashboard_balance_main')}}</p>
                  </div>
              </div>

              <div class="total">
                  <div class="img">
                      <span>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.4494 16.3152C11.7129 16.6987 12.035 17.0274 12.445 17.3014C13.0306 17.685 13.704 17.9042 14.4655 17.9042C16.1053 17.9042 17.4524 16.863 17.8623 15.4659C17.9502 15.1918 17.9794 14.918 17.9794 14.6166V14.3152C17.8329 12.8906 16.7495 11.7399 15.344 11.4112C15.0511 11.3562 14.7584 11.3289 14.4655 11.3289C14.3485 11.3289 14.202 11.3289 14.0848 11.3562C14.0262 11.3562 13.9677 11.3562 13.9091 11.3835C12.2401 11.6029 10.9516 12.9727 10.9516 14.6164C10.9516 15.2192 11.1273 15.8219 11.4494 16.3152ZM10.1904 16.3973C9.92686 15.8495 9.78041 15.2467 9.78041 14.6167C9.78041 12.6167 11.2153 10.9455 13.1478 10.3977C13.2648 10.3703 13.4113 10.3428 13.5577 10.3155C13.0892 9.60322 12.5327 9.05514 11.918 8.64429C11.6251 8.42509 11.3029 8.26075 10.9808 8.15125C10.6001 8.01423 10.2488 7.93205 9.89743 7.93205C9.60452 7.93205 9.28239 7.9869 8.98972 8.0964C8.6676 8.20591 8.34551 8.34293 8.0234 8.56212C6.53004 9.49356 5.15377 11.4937 5.15377 14.2332C5.15377 14.4798 5.18297 14.6989 5.30022 14.8908C5.38805 15.11 5.53451 15.2743 5.71016 15.4387C5.91524 15.603 6.17873 15.7674 6.50084 15.8771C7.37916 16.2602 8.81406 16.4246 10.1904 16.3973L10.1904 16.3973ZM20 12.9179C20 13.6302 19.6779 14.2329 19.1801 14.7261L19.1509 14.7535C19.063 17.1096 16.9839 19 14.4656 19C13.0601 19 11.8008 18.4246 10.9517 17.5207C8.63851 17.7125 6.03237 17.3288 4.86096 16.2603C4.74392 16.1508 4.65588 16.0411 4.53884 15.9316C3.0161 15.8219 1.58136 15.4384 0.819911 14.7261C0.29293 14.2331 0 13.6304 0 12.9179C0 11.4386 0.526981 9.79468 1.40551 8.53434C1.84466 7.90426 2.34265 7.41102 2.89886 7.02747C2.9867 6.9453 3.01591 6.8356 3.04532 6.7261C3.07453 6.56175 3.01611 6.36988 2.89886 6.23306C2.37188 5.68517 2.02034 4.94541 2.02034 4.12346C2.02034 2.39743 3.51369 1.00024 5.35854 1.00024C6.20763 1.00024 6.96913 1.30162 7.55473 1.79465C8.19895 1.30161 8.98963 1.02754 9.86795 1.02754C10.8051 1.02754 11.6542 1.35624 12.2984 1.87679C12.884 1.32891 13.7039 1 14.6116 1C16.4565 1 17.9498 2.39718 17.9498 4.12322C17.9498 4.91763 17.6277 5.65738 17.0713 6.23281C16.9542 6.39716 16.9248 6.56151 16.9248 6.72585C16.9248 6.83536 16.9835 6.94505 17.0713 7.02723C17.6277 7.41077 18.1255 7.90402 18.5354 8.53409C19.4435 9.79463 20 11.4383 20 12.9178L20 12.9179ZM18.9166 13.2193C18.9458 13.1371 18.9458 13.0274 18.9458 12.9179C18.9458 9.41114 16.4275 7.2468 14.6413 7.2468C14.0849 7.2468 13.4406 7.466 12.8258 7.84953C13.3528 8.23307 13.8214 8.75362 14.2607 9.35639C14.4658 9.63044 14.6414 9.90428 14.7877 10.2332C16.7204 10.37 18.3015 11.5755 18.9166 13.2194L18.9166 13.2193ZM16.4569 5.35644C16.7204 5.00023 16.8961 4.58934 16.8961 4.12364C16.8961 2.94568 15.8711 1.9867 14.612 1.9867C13.9678 1.9867 13.4114 2.23323 13.0014 2.61678C13.3528 3.16466 13.587 3.79473 13.587 4.45235C13.587 4.94539 13.47 5.38379 13.2941 5.82219C13.6749 6.09623 14.1432 6.23306 14.6412 6.23306C15.2855 6.23306 15.8711 5.98653 16.281 5.57549C16.3104 5.52083 16.3983 5.43866 16.4569 5.35648L16.4569 5.35644ZM12.328 4.39746C12.328 3.10982 11.2152 2.06865 9.83892 2.06865C8.46258 2.06865 7.3498 3.10977 7.3498 4.39746C7.3498 5.6851 8.46258 6.72628 9.83892 6.72628C11.2446 6.72628 12.328 5.68515 12.328 4.39746ZM6.1787 4.47964C6.1787 3.73988 6.41299 3.08246 6.82292 2.53438C6.41298 2.20567 5.91522 2.01379 5.32956 2.01379C4.07052 2.01379 3.04553 2.97277 3.04553 4.15073C3.04553 4.61645 3.19198 5.02752 3.48468 5.38353C3.57251 5.46571 3.63114 5.54788 3.68976 5.63006C4.0997 6.04093 4.68531 6.28763 5.32953 6.28763C5.76868 6.28763 6.17862 6.17812 6.50072 5.95892C6.32506 5.49321 6.17861 5.00014 6.17861 4.4796L6.1787 4.47964ZM5.50526 9.35624C5.94441 8.69867 6.47158 8.17828 7.05723 7.76724C6.50081 7.41102 5.88604 7.21935 5.35885 7.21935C3.57261 7.21935 1.05432 9.38359 1.05432 12.8905C1.05432 13.3289 1.20077 13.6849 1.55209 13.9862C2.02066 14.3971 2.9576 14.6711 4.01177 14.7806C3.95315 14.5888 3.95315 14.3971 3.95315 14.1779C3.95335 12.5616 4.50978 10.7533 5.50533 9.35614L5.50526 9.35624Z" fill="#F59D00"/>
                                <path d="M14.3368 16.6203C13.9456 16.5888 13 16.4938 13 15.9557C13 15.7025 13.1956 15.4811 13.4239 15.4811C13.6195 15.4811 13.9129 15.7343 14.3368 15.7343V14.8482C13.3587 14.5634 13.0328 14.2154 13.0328 13.709C13.0328 12.9494 13.6195 12.4748 14.3368 12.4115V12.1583C14.3368 12.0634 14.4021 12 14.4999 12C14.6302 12 14.6629 12.0634 14.6629 12.1583V12.4115C15.0216 12.4115 15.7064 12.5379 15.7064 13.0128C15.7064 13.2344 15.5433 13.4242 15.3152 13.4242C15.0869 13.4242 14.924 13.2026 14.6632 13.2026V13.9937C15.3152 14.1836 16 14.4683 16 15.2594C16 16.1455 15.2502 16.557 14.6632 16.5885V16.8417C14.6632 16.9366 14.5979 17 14.5001 17C14.3698 17 14.3371 16.9366 14.3371 16.8417L14.3368 16.6203ZM14.3368 13.2026C14.1412 13.2342 14.0107 13.3609 14.0107 13.5823C14.0107 13.7722 14.1737 13.8671 14.3368 13.8989V13.2026ZM14.6955 15.7343C14.891 15.7343 15.0216 15.5445 15.0216 15.3546C15.0216 15.1015 14.8913 15.0065 14.6955 14.9432V15.7343Z" fill="#F59D00"/>
                            </svg>
                      </span>
                  </div>
                  <div class="balance">
                      <span class="text" style="color: #F59D00">{{$primNum(portfolio.balancePartner)| formatThousands}}</span>
                      <p class="semi"><span class="m-r">USDT</span> {{__('dashboard_balance_partner')}}</p>
                  </div>
              </div>

              <div class="total">
                  <div class="img">
                      <span><img src="/newfrontend/images/top-coin.svg" alt=""></span>
                  </div>
                  <div class="balance">
                      <span class="text" style="color: #FF0000">{{$primNum(portfolio.balanceMC) | formatThousands}} </span>
                      <p class="semi"><span class="m-r">MC</span> <span class="m">(≈${{$primNum(portfolio.balanceMC*portfolio.courseMC) | formatThousands}})</span></p>
                  </div>
              </div>

          </div>
          <div class="balance-btn">
              <v-btn class="btn-white-new" :to="{name: 'withdraw'}">{{__('withdraw')}}</v-btn>
              <v-btn class="btn-green-new" :to="{name: 'deposit'}">{{__('deposit')}}</v-btn>
          </div>
      </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                value : 0
            }
        },
        props: {
            info: {
                type: Object
            }
        },
        computed: {
            portfolio() {
                return this.$store.state.auth.portfolio
            },
        },
        created() {
            this.turnoverValue();
        },
        methods:{
            turnoverValue() {

                let start= this.portfolio.rang_turnover;

                let turnover= this.portfolio.turnover;

                let end= this.portfolio.next_rang_turnover;
                this.value= (turnover-start)/((end-start)/100);
            },
        },
    }
</script>

<style>

</style>
